import { useNavigate } from "react-router-dom";
import { Bell, Plus } from "lucide-react";
import { PageHeader } from "@/components/control/PageHeader";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { Section, Loadable, Empty, Status, RowLink, ActionButton, useLoad, fmt, can } from "@/components/control/kit";

export function jobFields(groups, job = {}) {
  return [
    { name: "title", label: "Titel", required: true, default: job.title },
    { name: "body", label: "Nachricht", type: "textarea", required: true, default: job.body, help: "Kurz und verständlich, höchstens 1000 Zeichen." },
    { name: "group_id", label: "Empfängerkreis", type: "select", required: true, default: job.target?.group_id,
      options: groups.map((g) => ({ value: g.id, label: `${g.name} (${g.members_count} Mitglieder)` })) },
  ];
}

export default function Notifications() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const st = useLoad("/notifications/jobs");
  const groups = useLoad(can(user, "notifications:manage") ? "/notifications/groups" : null);
  return (
    <div>
      <PageHeader title="Benachrichtigungen" subtitle="In-App-Nachrichten an Kreise verfassen, Empfänger prüfen und Versand planen." icon={Bell}
        actions={can(user, "notifications:manage") && groups.data && (
          <ActionButton label="Benachrichtigung verfassen" icon={Plus} variant="default" testId="create-notification" fields={jobFields(groups.data.groups)}
            page="neu" pageSubtitle="Wähle erst Inhalt und Kanal. Die Empfängerprüfung folgt danach."
            submitLabel="Entwurf speichern" description="Kanal: Mitglieder-App. E-Mail-Versand ist nicht eingerichtet."
            onSubmit={async (v) => { const { data } = await api.post("/notifications/jobs", v); navigate(`/benachrichtigungen/${data.job.id}`, { replace: true }); return "Entwurf gespeichert."; }} />
        )} />
      <Section title="Versandaufträge" testId="notifications-section">
        <Loadable state={st}>
          {(d) => (
            <div className="overflow-x-auto">
              <Table data-testid="notifications-table">
                <TableHeader><TableRow><TableHead>Titel</TableHead><TableHead>Empfängerkreis</TableHead><TableHead>Geplant</TableHead>
                  <TableHead>Ergebnis</TableHead><TableHead>Status</TableHead></TableRow></TableHeader>
                <TableBody>
                  {d.jobs.length === 0 && <TableRow><TableCell colSpan={5}><Empty /></TableCell></TableRow>}
                  {d.jobs.map((j) => (
                    <TableRow key={j.id} data-testid={`job-row-${j.id}`}>
                      <TableCell><RowLink to={`/benachrichtigungen/${j.id}`} testId={`job-link-${j.id}`}>{j.title}</RowLink></TableCell>
                      <TableCell className="text-sm">{j.target?.group_name || "–"}</TableCell>
                      <TableCell className="text-sm">{fmt(j.scheduled_at)}</TableCell>
                      <TableCell className="text-sm">{j.result ? `${j.result.delivered}/${j.result.total} zugestellt` : "–"}</TableCell>
                      <TableCell><Status value={j.status} /></TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
          )}
        </Loadable>
      </Section>
    </div>
  );
}
